import React from "react";
import { Select, Typography, Row, Col, Form, Input,  } from "antd";


const { Option } = Select;

export default function ProductDetails() {
 
  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  return (
    <>
      <Row>
        <Typography.Title level={4} style={{ fontFamily: "Gilroy" }}>
          Enter details
        </Typography.Title>
      </Row>

      <Row style={{ marginTop: "2rem" }}>
        <Col span={24}>
          <Form.Item label="Description" name="description" {...formItemLayout}>
            <Input placeholder="Describe your product" />
          </Form.Item>
          <Form.Item label="Price" {...formItemLayout}>
            <Input.Group
              style={{ display: "flex", justifyContent: "space-between" }}
              compact
            >
              <Form.Item noStyle name="currency" {...formItemLayout}>
                <Select
                  placeholder="Currency"
                  style={{ width: "15%" }}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {/* TODO: fill currency */}
                  <Option value="INR">INR</Option>
                  <Option value="USD">USD</Option>
                  <Option value="EUR">EUR</Option>
                  <Option value="GBP">GBP</Option>
                </Select>
              </Form.Item>
              <Form.Item name="price" noStyle>
                <Input
                  style={{
                    width: "55%",
                    marginLeft: "0.5rem",
                    marginRight: "0.5rem",
                  }}
                  type="number"
                  placeholder="Enter the Price"
                />
              </Form.Item>
              <Form.Item noStyle name="quantity" {...formItemLayout}>
                <Select
                  placeholder="Quantity"
                  style={{ width: "30%" }}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value="per-piece">per piece</Option>
                  <Option value="per-square-metre">per sq. metre</Option>
                  <Option value="per-square-ft">per sq. feet</Option>
                </Select>
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Row gutter={10}>
            <Col span={12}>
              <Form.Item
                label="Sampling Time"
                name="sampling_lead_time"
                {...formItemLayout}
              >
                <Input placeholder="Sampling time eg: 1 week, 4 days .." />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Production Time"
                name="production_lead_time"
                {...formItemLayout}
              >
                <Input placeholder="Production lead time eg: 1 week, 4 days .." />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label="Minimum order quantity"
            name="moq"
            {...formItemLayout}
          >
            <Input placeholder="Enter MOQ eg: 1000 pieces, 1000 sq. m " />
          </Form.Item>
          <Form.Item label="Internal Cost" {...formItemLayout}>
            <Input.Group
              style={{ display: "flex", justifyContent: "space-between" }}
              compact
            >
              <Form.Item noStyle name="internal_currency" {...formItemLayout}>
                <Select
                  placeholder="Currency"
                  style={{ width: "15%" }}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {/* TODO: fill currency */}
                  <Option value="INR">INR</Option>
                  <Option value="USD">USD</Option>
                  <Option value="EUR">EUR</Option>
                  <Option value="GBP">GBP</Option>
                </Select>
              </Form.Item>
              <Form.Item name="internal_price" noStyle>
                <Input
                  style={{
                    width: "55%",
                    marginLeft: "0.5rem",
                    marginRight: "0.5rem",
                  }}
                  type="number"
                  placeholder="Enter the Price"
                />
              </Form.Item>
              <Form.Item noStyle name="internal_quantity" {...formItemLayout}>
                <Select
                  placeholder="Quantity"
                  style={{ width: "30%" }}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value="per-piece">per piece</Option>
                  <Option value="per-square-metre">per sq. metre</Option>
                  <Option value="per-square-ft">per sq. feet</Option>
                </Select>
              </Form.Item>
            </Input.Group>
          </Form.Item>

          <Row>
            {/* <Space align="baseline" direction="horizontal">
              <Typography.Title level={5} style={{ fontFamily: "Avenir" }}>
                Is this product sourced from a vendor?
              </Typography.Title>

              <Switch
                size="small"
                checkedChildren="Yes"
                unCheckedChildren="No"
                onChange={handleVendorSwitch}
              />
            </Space> */}
          </Row>
          <Form.Item
            label="Name of the vendor"
            name="vendor"
            // hidden={!Vendor}
            {...formItemLayout}
          >
            <Input placeholder="Enter name of the vendor" />
          </Form.Item>
          <Form.Item
            label="Vendor Price"
            name="vendorblock"
            {...formItemLayout}
            // hidden={!Vendor}
          >
            <Input.Group
              style={{ display: "flex", justifyContent: "space-between" }}
              compact
            >
              <Form.Item noStyle name="vendor_currency" {...formItemLayout}>
                <Select
                  placeholder="Currency"
                  style={{ width: "15%" }}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {/* TODO: fill currency */}
                  <Option value="INR">INR</Option>
                  <Option value="USD">USD</Option>
                  <Option value="EUR">EUR</Option>
                  <Option value="GBP">GBP</Option>
                </Select>
              </Form.Item>
              <Form.Item name="vendor_price" noStyle>
                <Input
                  style={{
                    width: "55%",
                    marginLeft: "0.5rem",
                    marginRight: "0.5rem",
                  }}
                  type="number"
                  placeholder="Enter the Price"
                />
              </Form.Item>
              <Form.Item noStyle name="vendor_quantity" {...formItemLayout}>
                <Select
                  placeholder="Quantity"
                  style={{ width: "30%" }}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value="per-piece">per piece</Option>
                  <Option value="per-square-metre">per sq. metre</Option>
                  <Option value="per-square-ft">per sq. feet</Option>
                </Select>
              </Form.Item>
            </Input.Group>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}
